import { AB_TEST } from '@abTests';
import { useFeatureFlags } from '@context/launch-darkly/LDProvider';
import { isAbTestEnabled } from '@helpers/utils';

import { useAbTest } from './useAbTest/useAbTest';

export const useNewPdDesignEnabled = () => {
  const abTestValue = useAbTest();
  const abTestEnabled = isAbTestEnabled(abTestValue, AB_TEST.NEW_PD_DESIGN);
  const { newPdDesign } = useFeatureFlags();

  return abTestEnabled || newPdDesign;
};
